window.addEventListener('load', () => {
    class CartUpsellProductSwiperSlide extends HTMLElement {
        constructor() {
            super();
            const slideAmount = this.classList.contains('cart__footer_drawer_collection') ? 1.6 : 2.1;
            new Swiper(this, {
                slideToClickedSlide: true,
                centeredSlides: false,
                slidesPerView: 1.3,
                spaceBetween: 12,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: slideAmount,
                    }
                }
            });
        }
    }
    customElements.define("cart-swiper-container", CartUpsellProductSwiperSlide);
});